import React, { useEffect, useState } from "react";
import { Modal, Input, Button, Switch, DatePicker } from "antd";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { t } from "i18next";
import { toast } from "react-toastify";

const ExpiryModal = ({
  visible,
  onClose,
  onSave,
  productIndex,
  initialData,
  purchaseQty,
  freeQty,
  initialAlertDays,
  initialExpiryAlert
}) => {

  const [expiryData, setExpiryData] = useState([
    {
      batchNumber: "",
      qty: "",
      manufactureDate: null,
      shelfLife: "",
      expiryDate: null,
    },
  ]);

  const [expiryAlert, setExpiryAlert] = useState(false);
  const [alertDays, setAlertDays] = useState("");
  const [totalQty, setTotalQty] = useState(0);

  useEffect(() => {
    if (visible) {
      if (initialData && initialData.length > 0) {
        setExpiryData(initialData);
        setExpiryAlert(initialExpiryAlert);
        setAlertDays(initialAlertDays);
      } else {
        setExpiryData([
          {
            batchNumber: "",
            qty: "",
            manufactureDate: null,
            shelfLife: "",
            expiryDate: null,
          },
        ]);
        setExpiryAlert(false);
        setAlertDays("");
      }
      setTotalQty(0);
    }
  }, [visible, initialData]);

  const handleAddRow = () => {
    if (expiryData.length < 10) {
      setExpiryData([
        ...expiryData,
        {
          batchNumber: "",
          qty: "",
          manufactureDate: null,
          shelfLife: "",
          expiryDate: null,
        },
      ]);
    } else {
      toast.error("You can only add up to 10 rows.");
    }
  };

  const handleChange = (index, key, value) => {
    const newData = [...expiryData];

    if (key === "qty" || key === "shelfLife") {
      let numericValue = parseInt(value, 10) || 0;
      if (numericValue < 0) numericValue = 0;

      newData[index][key] = numericValue;

      if (key === "qty") {
        const newTotalQty = newData.reduce(
          (acc, item) => acc + (item.qty || 0),
          0
        );
        setTotalQty(newTotalQty);
      }
    } else {
      newData[index][key] = value;
    }

    setExpiryData(newData);
  };

  const handleManufactureDateChange = (index, date) => {
    const newData = [...expiryData];
    newData[index].manufactureDate = date;
    setExpiryData(newData);
  };

  const handleDateChange = (index, date) => {
    const newData = [...expiryData];
    newData[index].expiryDate = date;
    setExpiryData(newData);
  };
  console.log("expireData==>",expiryData);
  

const handleSave = () => {

  if (totalQty > purchaseQty + freeQty) {
    toast.error(
      "Total quantity cannot exceed purchase quantity plus free quantity."
    );
    return;
  }

  for (let item of expiryData) {
    if (item.qty && !item.manufactureDate && !item.expiryDate) {
      toast.error("Please enter either Manufacture Date or Expiry Date.");
      return;
    }
  }

  onSave(expiryData, expiryAlert, alertDays, productIndex);
  onClose();
};

  const handleClose = () => {

    const filteredData = expiryData.filter(
      (item) =>
        item.batchNumber ||
        item.qty ||
        item.manufactureDate ||
        item.shelfLife ||
        item.expiryDate
    );

    setExpiryData(filteredData);
    onClose();
  };

const isButtonDisabled = expiryData.every((item) => {
  const isDateMissing = !item.manufactureDate && !item.expiryDate;
  const isShelfLifeMissing = item.manufactureDate && !item.shelfLife;
  const isShelfLifeInvalid = !item.manufactureDate && item.shelfLife;

  return (
    !item.batchNumber ||
    !item.qty ||
    isDateMissing ||
    isShelfLifeMissing ||
    isShelfLifeInvalid
  );
});

  return (
    <Modal
      title={t("Expiry")}
      visible={visible}
      onCancel={handleClose}
      footer={null}
      width={850}
    >
      <div className="expiry-page">

        {expiryData.map((item, index) => (
          <div key={index} className="flex mb-2 gap-2 flex-wrap">

           

            <Input
              type="number"
              placeholder={t("Qty")}
              value={item.qty}
              onChange={(e) => handleChange(index, "qty", e.target.value)}
              onWheel={(e) => e.target.blur()}
              min={0}
              style={{ width: "90px" }}
            />
             <Input
              placeholder={t("Batch Number")}
              value={item.batchNumber}
              onChange={(e) =>
                handleChange(index, "batchNumber", e.target.value)
              }
              style={{ width: "140px" }}
              disabled={!item.qty}
            />

            <DatePicker
              placeholder={t("Manufacture Date")}
              value={item.manufactureDate}
              onChange={(date) =>
                handleManufactureDateChange(index, date)
              }
              style={{ width: "190px" }}
              disabled={!item.qty  || item.expiryDate}
            />

            <Input
              type="number"
              placeholder={t("Shelf Life (Days)")}
              value={item.shelfLife}
              onChange={(e) =>
                handleChange(index, "shelfLife", e.target.value)
              }
              min={0}
              style={{ width: "140px" }}
              disabled={!item.manufactureDate || !item.qty  || item.expiryDate}
            />

            <DatePicker
              placeholder={t("Expiry Date")}
              value={item.expiryDate}
              onChange={(date) => {
                 handleChange(index, "shelfLife", '')
                handleDateChange(index, date)}}
                  style={{ width: "190px" }}
              disabled={!item.qty || item.manufactureDate}
            />

          </div>
        ))}

        <Button
          onClick={handleAddRow}
          type="dashed"
          style={{ marginBottom: "10px" }}
        >
          {t("Add")} +
        </Button>

        {/* <div>
          <span>{t("Expiry Alert")}</span>

          <Switch
            checked={expiryAlert}
            className={`ms-2 ${
              expiryAlert ? "bg-primaryBlue" : "bg-gray-400"
            }`}
            onChange={setExpiryAlert}
          />

          {expiryAlert && (
            <>
              <Input
                placeholder={t("XX Days")}
                value={alertDays}
                onChange={(e) => setAlertDays(e.target.value)}
                className="w-20 ms-2"
              />
              <span className="ms-2">{t("Days")}</span>
            </>
          )}
        </div> */}

        <div className="flex justify-end font-semibold mt-4">
          <Button
            onClick={handleSave}
            className="bg-primaryBlue"
            type="primary"
            disabled={isButtonDisabled}
          >
            {t("save")}
          </Button>
        </div>

      </div>
    </Modal>
  );
};

export default ExpiryModal;